import type {SetOptional} from 'type-fest';
import type {EnhancedUserSelector} from '../types';

export const getCorrectedUserSelector = <
	T extends
		| SetOptional<EnhancedUserSelector, 'userSelectorId'>
		| EnhancedUserSelector,
>(
	userSelector: T,
): T => {
	if (userSelector.all) {
		return {
			...userSelector,
			all: true,
			none: false,
			groups: [],
			users: [],
		};
	}

	if (
		userSelector.none ||
		(!userSelector.groups.length && !userSelector.users.length)
	) {
		return {
			...userSelector,
			all: false,
			none: true,
			groups: [],
			users: [],
		};
	}

	return userSelector;
};

export default getCorrectedUserSelector;
